+function ($) {
    'use strict';

    var SearcherResultFilter = function () {
        this.tmpFilter = '<div class="form-horizontal">'+
                                '<div class="form-group-row">'+
                                    '<div class="col-lr-1 col-md-1 col-sm-3 col-xsm-3">'+
                                        '<label class="form-label black" for="filter_resort">Курорт:</label>'+
                                        '<select class="form-control black bordered" data-filter="resort" id="filter_resort">'+
                                            '<option value="all">Все</option>'+
                                        '</select>'+
                                    '</div>'+
                                    '<div class="col-lr-1 col-md-1 col-sm-3 col-xsm-3">'+
                                        '<label class="form-label black" for="filter_hotel">Отель:</label>'+
                                        '<select class="form-control black bordered" data-filter="hotel" id="filter_hotel">'+
                                            '<option value="all">Все</option>'+
                                        '</select>'+
                                    '</div>'+
                                    '<div class="col-lr-1 col-md-1 col-sm-3 col-xsm-3">'+
                                        '<label class="form-label black" for="filter_amount-day">Количество дней:</label>'+
                                        '<select class="form-control black bordered" data-filter="amount-day" id="filter_amount-day">'+
                                            '<option value="all">Все</option>'+
                                        '</select>'+
                                    '</div>'+
                                '</div>'+
                            '</div>';
        this.$filterPanel = $(this.tmpFilter);
        this.$resortFilter = this.$filterPanel.find('#filter_resort');
        this.$hotelFilter = this.$filterPanel.find('#filter_hotel');
        this.$amountDayFilter = this.$filterPanel.find('#filter_amount-day');
        $('.search_result').prepend(this.$filterPanel);
    };

    /**
     * Форма бронирования тура
     * @constructor
     */
    var SearchedResultBookingForm = function() {
        this.templateMessage = '<div class="popup-window"><div class="container"></div></div>';
        this.$newOrder = $('#newOrder');
        this._token = this.$newOrder.data('token');
        this.$newOrder.find('[name="phone"]').mask('+7 (000) 000-00-00');
        var self = this;
        this.$newOrder.find('form').formValidator({
            'callback': function() {
                self.send(self.id);
                return false;
            }
        });

        this.$newOrder.bind('windowHidden', function() {
            $(this).find('input').trigger('focus');
        });
    };

    SearchedResultBookingForm.prototype.show = function(id) {
        this.$newOrder.popupWindow('show');
        this.id = id;
    };


    SearchedResultBookingForm.prototype.send = function (id){
        var data = this.$newOrder.find('form').serialize();
        $.ajax({
            'url': '/tours/order',
            'data': data +'&id=' + id + '&_token=' + this._token,
            'cache': false,
            'type': 'POST',
            'dataType': 'json',
            'context': this,
            'beforeSend': function () {
                this.$newOrder.find('button').addClass('disabled');
                this.$newOrder.find('button').attr('disabled', 'disabled');
            },
            'success' : function (data) {
                var $message = $(this.templateMessage);
                this.$newOrder.find('button').removeClass('disabled');
                this.$newOrder.find('button').removeAttr('disabled');
                this.$newOrder.popupWindow('hide');

                if(data.status == 1) {

                    $message.find('.container').text('Инфомация по туру запрошена. В ближайшее время с вами свяжуться наши специалисты.');
                    $('body').append($message);
                    $message.popupWindow('show');
                    setTimeout(function(){
                        $message.popupWindow('hide');
                        $message.remove();

                        if (data.backUrl) {
                            window.location = data.backUrl;
                        } else {
                            window.location = '/';
                        }
                    }, 2000);
                } else {
                    $message.find('.container').text('Произошла ошибка. Повторите попытку позже.');
                    $message.bind('windowHidden', function() {
                        $message.remove();
                    });
                    $('body').append($message);
                    $message.popupWindow('show');
                    setTimeout(function(){
                        $message.popupWindow('hide');
                    }, 2000);
                }
            },
            'error': function (xhr) {
                var $message = $(this.templateMessage);
                $message.find('.container').text('Произошла ошибка. Повторите попытку позже.');
                $message.bind('windowHidden', function() {
                    $message.remove();
                });
                $('body').append($message);
                $message.popupWindow('show');
                setTimeout(function(){
                    $message.popupWindow('hide');
                }, 2000);
            }
        });
    };



    var SearchedResultFabric = function() {
        this.tmpHotel = '<div class="hotel" data-stars="" data-hotel_name="" data-resort="">'+
                            '<div class="hotel__header">'+
                                '<img class="hotel__header__cover" src="">'+
                                '<div class="hotel__header__description">'+
                                    '<h2 class="hotel__name"><span></span></h2>'+
                                    '<div class="hotel__pikto">'+
                                        '<span class="hotel__pikto__item" title="Город/Курот/Регион">'+
                                            '<img class="hotel__pikto__img" src="/img/icon-place.svg">'+
                                        '</span>'+
                                        '<span class="hotel__pikto__item" title="Аэропорт прибытия">'+
                                            '<img class="hotel__pikto__img" src="/img/icon-airport.svg">'+
                                        '</span>' +
                                        '<span class="hotel__pikto__item rating" title="Рейтинг отеля">' +
                                            '<img class="hotel__pikto__img" src="/img/icon-rating.svg">' +
                                            '<a href="#">Показать рейтинг</a>' +
                                        '</span>'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                            '<div class="hotel__tours">'+
                            '</div>'+
                        '</div>';

        this.tmpTour = '<div class="hotel__tours__item" data-price="" data-amount_night="">'+
                            '<div class="hotel__tours__cell dates">'+
                                '<span></span>'+
                                '<span></span>'+
                            '</div>'+
                            '<div class="hotel__tours__cell info">'+
                                '<span></span>'+
                                '<span></span>'+
                            '</div>'+
                            '<div class="hotel__tours__cell price">'+
                                '<span><strong></strong> руб.</span>'+
                                '<span></span>'+
                            '</div>'+
                            '<div class="hotel__tours__cell book">'+
                                '<button class="btn btn-danger" data-id="" title="Запрос">' +
                                    '<span class="hidden-res-xsm">+</span>' +
                                    '<span class="show-res-xsm">Запрос</span>' +
                                '</button>'+
                            '</div>'+
                        '</div>';

        this.tmpNextBtn = '<div class="ajax-paginator">'+
                                '<a href="#" class="btn btn-danger ajax-paginator__link">Еще</a>'+
                           '</div>';

        this.tmpMoreToursBtn = '<div class="hotel__tours__more">' +
                                    '<a href="#" class="btn btn-info" data-toggle_text="Скрыть">Показать все</a>' +
                               '</div>';

        this.$dataContainer = $('.search_result');

        this.orderPopup = new SearchedResultBookingForm();



        this.loadResult();
    };

    //Числительные формы
    //n - число, forms - массив с вариантами
    SearchedResultFabric.prototype.pluralForm = function ( n, forms ) {
        return forms[(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2) ];
    };



    SearchedResultFabric.prototype.loadResult = function(param, successCallBack) {
        var self = this;
        $.ajax({
            'url': '/tours/data',
            'data': param,
            'type': 'POST',
            'cache': false,
            'context': self,
            'dataType': 'json',
            'beforeSend': function () {
                window.preloader.canHide = false;
                window.preloader.show();
            },
            'complete': function () {
                window.preloader.canHide = true;
                window.preloader.hide();
            },
            'success' : function(data) {
                if (data.amount > 0) {
                    this.sortAndSetData(data);
                    $('.preloader').remove();
                } else {
                    $('.preloader').empty().text('К сожалению ничего не найдено.');
                }

                if (data.nextPage === 'true') {
                    if ($('body').find('.ajax-paginator').length == 0) {
                        this.generateNextPageBtn();
                    } else {
                        $('body').find('.ajax-paginator').find('.btn').removeClass('disabled');
                        this._scrollToTop();
                    }
                } else {
                    $('body').find('.ajax-paginator').remove();
                }

                if (typeof successCallBack === 'function') {
                    successCallBack();
                }
            },
            'error': function(xhr, textStatus) {
                if ($('body').find('.ajax-paginator').length != 0) {
                    $('body').find('.ajax-paginator').remove();
                    this._scrollToTop();
                }
            },
        });
    };

    /**
     * Быстрое перемещение к блоку хлебных крошек
     * @private
     */
    SearchedResultFabric.prototype._scrollToTop = function () {
        var top = $('.breadcrumb').offset().top;
        $('html, body').animate({scrollTop: top}, 0);
    };

    SearchedResultFabric.prototype.generateNextPageBtn = function() {
        var nextPageBtn = $(this.tmpNextBtn);
        var self = this;
        nextPageBtn.find('.btn').bind('click', function() {
            if (!$(this).hasClass('disabled')) {
                $(this).addClass('disabled');
                self.loadResult('more=1');
            }
            return false;
        });

        $('.container.data').append(nextPageBtn);
    };

    SearchedResultFabric.prototype.removeNextPageBtn = function () {
        var $nextPage = $('body').find('.ajax-paginator');
        if ($nextPage.length > 0) $nextPage.remove();
    };


    SearchedResultFabric.prototype.sortAndSetData = function(data) {
        var $hotel;
        var position = data.position;
        var result = data.data;
        var amountElements = data.amount+data.position;
        var newClassFlag = ($('.hotel').length != 0);
        if (newClassFlag) {
            $('body').find('.hotel__tours__item').removeClass('new');
        }
        if (data.position >= 1500) {
            this.removeNextPageBtn();
        }
        for (var i = data.position; i < amountElements; i++) {
            if ($hotel = this.findHotel(result[i])) {
                //Наши отель
                //Надо сгенерировать тур
                var $tour = this.generateTour(result[i], i, newClassFlag);
                var price = $tour.data('price');
                //Проверить все туры в отеле и поставить тур в нужное место
                var $toursInHotel = $hotel.find('.hotel__tours__item');
                var pastFlag = false;
                for (var j = 0; j < $toursInHotel.length; j++) {
                    if ($toursInHotel.eq(j).data('price') > price) {
                        $toursInHotel.eq(j).before($tour);
                        pastFlag = true;
                    }
                }
                if (!pastFlag) {
                    $hotel.find('.hotel__tours').append($tour);
                }
            } else {
                //Не нашли отель
                //Генерируем новый отель и добавляем в него тур
                $hotel = this.generateHotel(result[i], i);
                if (this.$dataContainer.find('.ajax-paginator').length > 0) {
                    this.$dataContainer.find('.ajax-paginator').before($hotel);
                } else {
                    this.$dataContainer.append($hotel);
                }
            }
        }
        // скрываем все туры, кроме первого
        this._postprocessHotelsTour();
    };

    /**
     * Функция, которая производить скрытие всех туров кроме первого,
     * для наилучшего отображения результатов поиска
     * @private
     */
    SearchedResultFabric.prototype._postprocessHotelsTour = function () {
        var $tourWrappers = $('.hotel__tours');
        for (var i = 0; i < $tourWrappers.length; i++) {
            if ($tourWrappers.eq(i).find('.hotel__tours__item').length > 1) {
                $tourWrappers.eq(i).find('.hotel__tours__item:not(:first)').css('display', 'none');
                $tourWrappers.eq(i).parent().find('.hotel__tours__more').remove();
                var $more = $(this.tmpMoreToursBtn);
                var amountNew = $tourWrappers.eq(i).find('.hotel__tours__item.new').length;
                if (amountNew > 0) {
                    var text = $more.find('.btn').text();
                    text += ' ( новых: ' + amountNew + ')';
                    $more.find('.btn').text(text);
                }
                $more.find('.btn').bind('click', function () {
                    // преключение режима отображения найденных туров
                    if (!$(this).hasClass('open')) {
                        $(this).closest('.hotel').find('.hotel__tours__item').css('display', 'block');
                        $(this).addClass('open');
                    } else {
                        $(this).closest('.hotel').find('.hotel__tours__item:not(:first)').css('display', 'none');
                        $(this).removeClass('open');
                    }

                    var currentText = $(this).text();
                    var dataText = $(this).data('toggle_text');
                    $(this).text(dataText);
                    $(this).data('toggle_text', currentText);
                    return false;
                });
                $tourWrappers.eq(i).after($more);
            }

        }
    };

    SearchedResultFabric.prototype.findHotel = function(data) {
        var $hotels = $('.hotel');
        for (var i = 0; i < $hotels.length; i++) {
            if (($hotels.eq(i).data('stars') === data.stars) &&
                ($hotels.eq(i).data('hotel_name') === data.hotel_name) &&
                ($hotels.eq(i).data('resort') === data.resort)) {
                return $hotels.eq(i);
            }
        }
        return null;
    };

    SearchedResultFabric.prototype.generateTour = function(data, key, newClass) {
        var self = this;
        var $tour = $(this.tmpTour);
        if (newClass) $tour.addClass('new');
        var price = parseFloat(data.hotel_tour_price);
        $tour.data('price', price);
        $tour.attr('data-price', price);
        $tour.data('amount_night', data.amount_night);
        $tour.attr('data-amount_night', data.amount_night);
        $tour.find('.dates span').eq(0).text('Заезд: ' + data.check_in + ' ( ' + data.check_in_day_name + ' )');
        $tour.find('.dates span').eq(1).text('Выезд: ' + data.check_out);
        $tour.find('.info span').eq(0).text('Тип номера: ' + data.hotel_type_room);
        $tour.find('.info span').eq(1).text('Тип питания: ' + data.hotel_food_type_name);
        $tour.find('.price strong').text(price.toLocaleString('ru-RU'));
        $tour.find('.price span').eq(1).text('за ' + data.amount_night + ' ' +
            this.pluralForm(data.amount_night, ['ночь', 'ночи', 'ночей']));
        $tour.find('.book .btn.btn-danger').attr('data-id', key);
        $tour.find('.book .btn.btn-danger').bind('click', function() {
            var id = $(this).data('id');
            self.orderPopup.show(id);
        });
        return $tour;
    };

    SearchedResultFabric.prototype.generateHotel = function(data, key) {
        var $tour = this.generateTour(data, key);
        var $hotel = $(this.tmpHotel);
        var hotel_name = data.hotel_name;
        if (data.stars && data.stars !== 'Нет') {
            hotel_name = hotel_name + '(' + data.stars + '<sup>*</sup>)';
        }
        $hotel.attr('data-stars', data.stars);
        $hotel.attr('data-hotel_name', data.hotel_name);
        $hotel.attr('data-resort', data.resort);
        $hotel.data('base_id', key);
        $hotel.data('stars', data.stars);
        $hotel.data('hotel_name', data.hotel_name);
        $hotel.data('resort', data.resort);
        new HotelRating($hotel);
        new HotelFinder($hotel.find('.hotel__name'));
        $hotel.find('.hotel__header__cover').attr('src', '/tours/image/' + key);
        $hotel.find('.hotel__name').html(hotel_name);
        $hotel.find('.hotel__pikto__item').eq(0).append(data.resort);
        $hotel.find('.hotel__pikto__item').eq(1).append(data.airport_of_arrival.airport_name);
        $hotel.find('.hotel__tours').append($tour);
        return $hotel;
    };
    
    var HotelRating = function($item) {
        this.$hotel = $item;
        this.hotelName = this.$hotel.data('hotel_name');
        this.token = $('[name="_token"]').val();
        this.base_id =  this.$hotel.data('base_id');
        var self = this;
        this.$hotel.find('.rating > a').bind('click', function () {
            self.loadRating();
            $(this).remove();
            return false;
        });
    };

    HotelRating.prototype.loadRating = function () {
        $.ajax({
            type: 'POST',
            url: '/tours/hotel_rating',
            data: 'hotel_name=' + this.hotelName +
            '&base_id=' + this.base_id + '&_token=' + this.token,
            cache: false,
            context: this,
            dataType: 'json',
            success: function(data) {
                var $rating = this.$hotel.find('.rating');
                if (data['rating']) {
                    $rating.append(data['rating']);
                } else {
                    $rating.append(0);
                }
                $rating.css({
                    'display' : 'block',
                });
            },
            error: function(data) {
                var $rating = this.$hotel.find('.rating');
                $rating.append(0);
                $rating.css({
                    'display' : 'block',
                });
            }
        });
    };

    var FastHotelGallery = function (item) {
        this.$element = $(item);
        this.$prev = this.$element.find('.hotel-images-arrow.prev');
        this.$next = this.$element.find('.hotel-images-arrow.next');
        this.$showImg = this.$element.find('.hotel-image-main');
        this.$thumbImages = this.$element.find('.hotel-images-item');

        this.curPos = 0;
        this.amountImg = this.$thumbImages.length;


        var self = this;
        this.$prev.bind('click', function () {
            self.prev();
            return false;
        });

        this.$next.bind('click', function() {
            self.next();
            return false;
        });

        this.$thumbImages.bind('click', function () {
            self.thumbSelect(this);
            return false;
        });
    };

    FastHotelGallery.prototype.changeSelectThumb = function (pos) {
        if (pos >= 0 && pos < this.amountImg) {
            this.$thumbImages.removeClass('active');
            this.$thumbImages.eq(pos).addClass('active');
            this.curPos = pos;
            var src = this.$thumbImages.eq(pos).find('img').attr('src');
            this.setBigImage(src);
        }
    };

    FastHotelGallery.prototype.setBigImage = function (src) {
        var self = this;
        this.$showImg.animate({
            'opacity' : 0,
        }, {
            'duration': 600,
            'complete': function () {
                self.$showImg.attr('src', src);
                self.$showImg.unbind('load');
                self.$showImg.bind('load', function () {
                    self.$showImg.animate({
                        'opacity' : 1,
                    }, {
                        'duration': 600,
                    });
                });
            }
        });
    };

    FastHotelGallery.prototype.next = function () {
        if ((this.curPos + 1) < this.amountImg) {
            this.curPos++;
        } else {
            this.curPos = 0;
        }

        this.changeSelectThumb(this.curPos);
    };

    FastHotelGallery.prototype.prev = function () {
        if ((this.curPos - 1) >= 0) {
            this.curPos--;
        } else {
            this.curPos = this.amountImg - 1;
        }

        this.changeSelectThumb(this.curPos);
    };

    FastHotelGallery.prototype.thumbSelect = function (element) {
        var $element = $(element);
        if (!$element.hasClass('active')) {
            var pos = $element.index();
            this.curPos = pos;
            this.changeSelectThumb(this.curPos);
        }
    };

    var HotelFinder = function($item) {
        this.modalTemplate = '<div class="popup-window" id="searchedHotel">' +
                                '<div class="container">' +
                                    '<div class="popup-window__close-cross popup-close">x</div>' +
                                    '<div class="hotel-info error">Во время выполнения запроса произошла ошибка, попробуйте повторить попытку позже.' +
                                        '<div class="hotel-additional">' +
                                            '<span class="hotel-additional-title">Вы можете продолжить поиск используя:</span>' +
                                            '<a href="" class="hotel-additional-item google" target="_blank" title="Поиск в гугл"></a>' +
                                            '<a href="" class="hotel-additional-item yandex" target="_blank" title="Поиск в яндекс"></a>' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="hotel-info">' +
                                        '<div class="hotel-general-info">' +
                                            '<div class="hotel-image"><img src=""></div>' +
                                            '<div class="hotel-title">' +
                                                '<span class="hotel-recommended">Рекомендуем</span>' +
                                                '<h3 class="hotel-name"></h3>' +
                                                '<div class="hotel-placement"></div>' +
                                                '<div class="hotel-contacts">' +
                                                    '<a class="hotel-contacts-item phone" href=""></a>' +
                                                    '<a class="hotel-contacts-item site" target="_blank" href=""></a> ' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="hotel-description"></div>' +
                                        '<div class="hotel-location"><span class="hotel-location-title">Расположение отеля: </span></div>' +
                                        '<div class="hotel-map" data-latitude="" data-longitude=""></div>' +
                                        '<div class="hotel-data"><span class="hotel-data-title">Информация по отелю: </span></div>' +
                                        '<div class="hotel-images">' +
                                            '<div class="hotel-images-main">' +
                                                '<a href="#prev" class="hotel-images-arrow prev"></a>' +
                                                '<a href="#next" class="hotel-images-arrow next"></a>  ' +
                                                '<img src="" class="hotel-image-main">' +
                                            '</div>' +
                                            '<div class="hotel-images-wrapper">' +
                                                '<div href="" class="hotel-images-item"><img src="" class="hotel-images-thumb"></div>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="hotel-additional">' +
                                            '<span class="hotel-additional-title">Дополнительный поиск</span>' +
                                            '<a href="" class="hotel-additional-item google" target="_blank" title="Поиск в гугл"></a>' +
                                            '<a href="" class="hotel-additional-item yandex" target="_blank" title="Поиск в яндекс"></a>' +
                                        '</div>' +
                                    '</div>',
                                '</div>' +
                             '</div>';
        this.scriptApiSrc = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBD5JkJkg1mH0V4tn5if7LciTwjRtMquGI&callback=MapObserver.init';



        var $hotel = $item.closest('.hotel');
        this.hotelName = $hotel.data('hotel_name');
        this.stars = $hotel.data('stars');
        this.resort = $hotel.data('resort');
        this.country = $('#countryTo option:selected').val();
        this.token = $('[name="_token"]').val();
        this.base_id =  $hotel.data('base_id');
        
        var self = this;
        $item.bind('click', function () {
            self.search(this);
            return false;
        });
    };

    HotelFinder.prototype.search = function (element) {
        var $element = $(element);

        $.ajax({
            type: 'POST',
            url: '/tours/hotel_search',
            data: 'hotel_name=' + encodeURIComponent(this.hotelName) + '&stars=' + this.stars +
                  '&resort=' + this.resort + '&country=' + this.country +
                  '&base_id=' + this.base_id + '&_token=' + this.token,
            cache: false,
            context: this,
            dataType: 'json',
            beforeSend: function () {
                preloader.show();
            },
            success: function(data) {
                preloader.hide();
                var $modal = $(this.modalTemplate);
                if (data.success) {
                    $modal.find('.hotel-info.error').remove();
                    $modal.find('.hotel-general-info .hotel-image img').attr('src', $element.closest('.hotel__header').find('.hotel__header__cover').attr('src'));
                    if (data.recommended) {
                        $modal.find('.hotel-recommended').css({'display' : 'block'});
                    }
                    $modal.find('.hotel-name').text(data.name);
                    $modal.find('.hotel-placement').text(data.placement);

                    if (data.hotel_description) {
                        $modal.find('.hotel-description').text(data.hotel_description);
                    } else {
                        $modal.find('.hotel-description').remove();
                    }

                    if (data.location) {
                        $modal.find('.hotel-location').append(data.location);
                    } else {
                        $modal.find('.hotel-location').remove();
                    }

                    if (data.latitude && data.longitude) {
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.src = this.scriptApiSrc;
                        $modal.append(script);
                        MapObserver.setObserver(function (obs) {
                            var lat = parseFloat(data.latitude);
                            var lng = parseFloat(data.longitude);
                            var $map = $modal.find('.hotel-map');
                            $map.css({
                                'display' : 'block',
                            });
                            var MapFasade = obs.newMap($map[0]);

                            MapFasade.setCenter({
                                'lat' : lat,
                                'lng' : lng,
                            });
                            MapFasade.setPoint({
                                'lat' : lat,
                                'lng' : lng,
                                'title' : data.name,
                            });
                            MapFasade.setZoom(15);
                        });
                    } else {
                        $modal.find('.hotel-map').remove();
                    }

                    if (data.hotel_info) {
                        $modal.find('.hotel-data').append(data.hotel_info);
                    } else {
                        $modal.find('.hotel-data').remove();
                    }

                    if (data.phone || data.site) {
                        if (data.phone) {
                            $modal.find('.hotel-contacts .hotel-contacts-item.phone').attr('href', 'tel:' + data.phone).text(data.phone);
                        } else {
                            $modal.find('.hotel-contacts .hotel-contacts-item.phone').remove();
                        }

                        if (data.site) {
                            $modal.find('.hotel-contacts .hotel-contacts-item.site').attr('href', data.site).text(data.site);
                        } else {
                            $modal.find('.hotel-contacts .hotel-contacts-item.site').remove();
                        }
                    } else {
                        $modal.find('.hotel-contacts').remove();
                    }

                    if (data.photos) {
                        var $tpl = $modal.find('.hotel-images-item').clone();
                        $modal.find('.hotel-images-item').remove();
                        for (var i = 0; i < data.photos.length; i++) {
                            var $tmplThumb = $tpl.clone();
                            $tmplThumb.attr('href', data.photos[i]);
                            $tmplThumb.find('img').attr('src', data.photos[i]);
                            $modal.find('.hotel-images-wrapper').append($tmplThumb);
                            if (i == 0) {
                                $modal.find('.hotel-image-main').attr('src', data.photos[i]);
                                $tmplThumb.addClass('active');
                            }
                        }
                        new FastHotelGallery($modal.find('.hotel-images'));
                    } else {
                        $modal.find('.hotel-images').remove();
                    }
                    var $additional = $modal.find('.hotel-info .hotel-additional');
                    $additional.find('.google').attr('href', data.search_google);
                    $additional.find('.yandex').attr('href', data.search_yandex);



                } else {
                    $modal.find('.hotel-info:not(.error)').remove();
                    var $additional = $modal.find('.hotel-info.error .hotel-additional');
                    $additional.find('.google').attr('href', data.search_google);
                    $additional.find('.yandex').attr('href', data.search_yandex);
                }


                $('body').append($modal);
                $modal.popupWindow('show');
                $modal.bind('windowHidden', function() {
                    $modal.remove();
                });
            },
            error: function($xhr, $data) {
                preloader.hide();
                var $modal = $(this.modalTemplate);
                $modal.find('.hotel-info:not(.error)').remove();
                $modal.find('.hotel-info.error .hotel-additional').remove();
                $('body').append($modal);
                $modal.popupWindow('show');
                $modal.bind('windowHidden', function() {
                    $modal.remove();
                });
            }
        });
    };




    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            new SearchedResultFabric();
        });
    };



    var old = $.fn.ajaxPaginator;

    $.fn.searchedResultFabric = constructor;
    $.fn.searchedResultFabric.constructor = constructor;

    $.fn.searchedResultFabric.noConflict = function () {
        $.fn.searchedResultFabric = old;
        return this;
    }
}(jQuery);
    
$(document).ready(function() {
    $('.search_result').searchedResultFabric();
});